import React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import querystring from "querystring";
import { loginFromMedproId } from "~/store/user/userAction";

class AuthorizedPage extends React.Component {
  constructor(props) {
    super(props);
    const { IsAuthenticated, history } = this.props;
    if (!IsAuthenticated) {
      const params = window.location.pathname.split("/")[2];
      const parse = querystring.parse(params);
      this.props.loginFromMedproId(parse);
    } else {
      history.push("/");
    }
  }

  componentDidUpdate(prevProps) {
    const { history, IsAuthenticated, currentUrl } = this.props;
    if (IsAuthenticated && !prevProps.IsAuthenticated) {
      history.push(currentUrl);
    } else {
      history.push("/");
    }
  }

  render() {
    return <div>{}</div>;
  }
}

const mapStateToProps = state => {
  const {
    user: { IsAuthenticated },
    login: { currentUrl }
  } = state;
  return {
    IsAuthenticated,
    currentUrl
  };
};

export default connect(mapStateToProps, { loginFromMedproId })(
  withRouter(AuthorizedPage)
);
